"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuerySwitch = void 0;
var React = require("react");
var PropTypes = require("prop-types");
var react_router_1 = require("react-router");
var matches_query_1 = require("./matches-query");
/**
 * Example Usage:
 *
 * <QuerySwitch>
 *   <QueryRoute query={{"someKey": "someValue"}}>
 *     <span>Foo</span>
 *   </QueryRoute>
 *   <QueryRoute query={"someKey"}> //Any Value
 *     <span>Bar</span>
 *   </QueryRoute>
 * </QuerySwitch>
 *
 * In this case, only Foo will render.
 * Without the QuerySwitch, both Foo and Bar will render
 */
var QuerySwitch = /** @class */ (function (_super) {
    __extends(QuerySwitch, _super);
    function QuerySwitch() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuerySwitch.prototype.render = function () {
        var _a = this.props, children = _a.children, history = _a.history;
        var location = history.location;
        var search = this.props.search || location.search;
        var match = false;
        var child;
        React.Children.forEach(children, function (element) {
            if (match === false && React.isValidElement(element)) {
                var query = element.props.query;
                child = element;
                match = (0, matches_query_1.matchesQuery)(search, query);
            }
        });
        return match ? React.cloneElement(child, { queryMatch: true, search: search }) : null;
    };
    QuerySwitch.propTypes = {
        search: PropTypes.string,
        children: PropTypes.node,
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };
    QuerySwitch = __decorate([
        react_router_1.withRouter
    ], QuerySwitch);
    return QuerySwitch;
}(React.Component));
exports.QuerySwitch = QuerySwitch;
//# sourceMappingURL=query-switch.js.map